<template>
    <PageFrameContainer>
        <div class="checkout-container">
            <h2>
                Checkout
            </h2>

            <div class="products-table">
                <p class="header">Image</p>
                <p class="header">Product Name</p>
                <p class="header">Quantity</p>
                <p class="header">Unit Price</p>
                <p class="header">Total</p>
                <template v-for="product in Object.keys(cart)">
                    <div class="versions-track" :key="`${product}-track`"></div>
                    <router-link :to="{ name: resolveLink(product), params: {productId: product} }" class="product-name"
                                 :key="`${product}-link`">
                        <img :key="`${product}-img`" class="logo" :src="getImagePath(product)" :alt="product">
                    </router-link>
                    <router-link :to="{ name: resolveLink(product), params: {productId: product} }" class="product-name"
                                 :key="`${product}`">{{product|productLicenseTypeFilterWithKey}}
                    </router-link>
                    <p :key="`${product}-qty`">
                        {{cart[product]}}
                    </p>
                    <p :key="`${product}-price`">$ {{pricePerUnit(product)}}</p>
                    <p :key="`${product}-total`">$ {{totalUnitsPrice(product,cart[product])}}</p>
                </template>
            </div>
            <div class="total-table">
                <p>Sub-Total:</p>
                <p>$ {{subTotalPrice()}}</p>
                <div class="versions-track"></div>
                <p class="total">Total:</p>
                <p class="total">$ {{totalPrice()}}</p>
            </div>
            <div class="payment-method-table">
                <p class="header"> Payment method</p>
                <div class="versions-track"></div>
                <p>Please select the preferred payment method to use on this order.</p>
                <div class="tabs-payment-methods">


                    <input id="bank-transfer" type="radio" name="tabs-payment-methods" v-model="payMethod"
                           value="Bank-transfer" checked>
                    <label for="bank-transfer">
                        <img src="../../assets/icons/bank-transfer.svg" :alt="Bank-transfer"/>
                    </label>

                    <template v-if="$features.payment.paypal">
                        <input id="pay-pal" type="radio" name="tabs-payment-methods" v-model="payMethod" value="PayPal">
                        <label for="pay-pal">
                            <img src="../../assets/icons/paypal.svg" :alt="PayPal"/>
                        </label>
                    </template>
                    <template v-if="$features.payment.card">
                        <input id="card" type="radio" name="tabs-payment-methods" v-model="payMethod" value="Card">
                        <label for="card">
                            <img src="../../assets/icons/card.svg" :alt="Card"/>
                        </label>
                    </template>
                </div>
            </div>
            <router-link v-if="payMethod!=null && payMethod !== undefined" class="confirm-btn"
                         :to="{name:resolveLink(payMethod)}"
                         tag="button">
                Confirm order
            </router-link>
            <div class="not-confirm-order" v-else>
                <p>Please choose a payment method!</p>
                <button class="confirm-not-active">
                    Confirm order
                </button>
            </div>

        </div>
    </PageFrameContainer>
</template>

<script>
    import PageFrameContainer from "../../components/PageFrameContainer";

    export default {
        name: "CheckoutPage",
        components: {PageFrameContainer},
        props: [],
        data: function () {
            return {
                payMethod: "Bank-transfer"
            }
        },
        mounted: function () {

        },
        computed: {
            cart() {
                return this.$store.state.cart;
            }
        },
        methods: {
            addToCart() {
                console.info(`add to cart: ${this.productId}, 1`);
                this.$store.commit('addToCart', {product: this.productId, qty: 1});
            },
            getImagePath(_product) {
                switch (_product) {
                    case 'BW1Start':
                        return require(`../../assets/icons/logo_start.svg`);
                    case 'BW1Standard':
                        return require(`../../assets/icons/logo_standard.svg`);
                    case 'BW1Power':
                        return require(`../../assets/icons/logo_power.svg`);
                }
                return require(`../../assets/icons/logo_onebw.svg`);
            },
            pricePerUnit(_product) {
                return this.$prices.getProductPrice(_product, 'annualy');
            },
            totalUnitsPrice(_product, _qty) {
                return _qty * this.pricePerUnit(_product);
            },
            subTotalPrice() {
                return this.totalPrice();
            },
            totalPrice() {
                let cart = this.$store.state.cart;
                let products = Object.keys(cart);
                let totalQty = 0;
                for (let x of products)
                    totalQty += cart[x] * this.pricePerUnit(x);
                return totalQty;
            },
            resolveLink(_payMethod) {
                switch (_payMethod.toLowerCase()) {
                    case 'bank-transfer':
                        return 'bankTransfer';
                    case 'paypal':
                        return 'pay-pal';
                    case 'card':
                        return 'card-pay';
                }
            }
        }

    }
</script>

<style scoped lang="scss">
    @import "../../theme/theme";

    h2 {
        font-weight: 300;
        font-size: 2em;
        color: $primary20;
    }

    .checkout-container {
        display: grid;
        grid-template-rows: repeat(5, auto);
        margin-top: 2rem;

        .products-table {
            display: grid;
            grid-template-columns: repeat(5, auto);
            border: 1px solid $text40;
            border-radius: 0.3rem;
            margin-top: 2rem;

            p {
                text-align: center;
                font-weight: 300;
                font-size: 1rem;
                align-self: center;
                justify-self: center;
                padding-bottom: 1rem;
                padding-top: 1rem;
            }

            .product-name {
                font-weight: 400;
                font-size: 1.2rem;
                color: $primary20;
                align-self: center;
                justify-self: center;
            }

            .header {
                font-weight: 400;

            }

            img {
                justify-self: center;
                max-height: 7rem;
            }

            .versions-track {
                margin-bottom: 0;
                border-bottom: 0.1em solid $text20;
                z-index: -1;
                grid-column: 1/-1;
            }

            a {
                text-decoration: none;
                text-effect: none;
                font-size: 1.3em;
                color: $primary20;
                text-align: center;
                margin-left: 1rem;
                margin-right: 1rem;
            }

            a:hover {
                color: $primary80;
            }

            a img:hover {
                opacity: 0.7;
            }

        }

        .total-table {
            display: grid;
            grid-template-columns: auto auto;
            grid-template-rows: auto auto;
            justify-self: end;
            column-gap: 2rem;
            border: 1px solid $text20;
            border-radius: 0.2rem;
            margin-top: 2rem;

            p {
                border-right: 1px solid $text20;
                padding-right: 2rem;
                padding-left: 0.5rem;
                height: 2rem;
                padding-top: 0.4rem;
                font-size: 1.2rem;
            }

            .total {
                font-size: 1.4rem;
                font-weight: 400;
            }

            .versions-track {
                margin-bottom: 0;
                border-bottom: 1px solid $text20;
                z-index: -1;
                grid-column: 1/-1;
            }
        }

        .payment-method-table {
            display: grid;
            grid-template-columns: auto;
            grid-template-rows: auto auto auto;
            justify-self: start;

            margin-top: 2rem;
            border: 1px solid $text20;
            border-radius: 0.3rem;

            .header {
                background: $back60;
                padding: 0.5rem;
                font-weight: 400;
            }

            p {
                padding: 0.5rem;
                font-weight: 300;
            }

            .versions-track {
                margin-bottom: 0;
                border-bottom: 0.1em solid $text20;

                z-index: -1;
                grid-column: 1/-1;
            }

        }

        .tabs-payment-methods {
            display: grid;
            grid-template-columns: 1.5rem auto;
            grid-template-rows: auto auto;
            align-items: start;
            row-gap: 1rem;
            font-size: 0.8rem;
            padding: 0.5rem;

            input {
                align-self: center;

            }

            img {
                //max-height: 3rem;
                width: 5rem;
            }
        }

        button.confirm-btn {
            padding: 0.7em 2em;
            background: $primary20;
            border: 0;
            text-decoration: none;
            border-radius: 0.4rem;
            text-effect: none;
            font-size: 1em;
            align-self: center;
            justify-self: end;
            cursor: pointer;
            color: $primaryText100;
            transition: all .25s;
            margin-bottom: 2rem;
            margin-top: 2.7rem;
            outline: none;
        }

        button.confirm-btn:hover {
            background: $primary100;
        }

        .not-confirm-order {
            justify-self: end;
            justify-content: center;
            margin-top: 1rem;
            display: grid;

            button.confirm-not-active {
                padding: 0.7em 2em;
                background: $back60;
                border: 0;
                text-decoration: none;
                border-radius: 0.4rem;
                text-effect: none;
                font-size: 1em;
                align-self: center;
                justify-self: end;
                cursor: pointer;
                color: $primaryText100;
                transition: all .25s;
                margin-bottom: 2rem;
                outline: none;
            }

            p {
                align-self: center;
                justify-self: center;
                color: $error;
                margin-bottom: 0.5rem;
            }
        }
    }
</style>